import { CreateMarkerOptions, createMarker } from "Utils/mapbox";
import mapboxgl from "mapbox-gl";
import useUnmountedSignal from "./useUnmountedSignal";
import { useCallback, useRef, useState } from "react";

type MapboxStyles = "mapbox://styles/mapbox/light-v10" | "mapbox://styles/mapbox/streets-v11" | "mapbox://styles/liquidspace/ckpy2c5794fsi17mvwefqxp9n";
export type ControlPosition = Parameters<typeof mapboxgl.Map.prototype.addControl>[1];
export interface UseMapBoxOptions {
   style?: MapboxStyles,
   controlPosition?: ControlPosition
}
function useMapbox(options?: UseMapBoxOptions) {
   const {
      style = "mapbox://styles/liquidspace/ckpy2c5794fsi17mvwefqxp9n",
      controlPosition
   } = options || {};
   const mapContainerRef = useRef<HTMLDivElement | null>(null);
   const [center, setCenter] = useState({
      lng: -122.405033,
      lat: 37.772004
   });
   const [zoom, setZoom] = useState(12);
   const mapRef = useRef<mapboxgl.Map>();

   const unmountedSignal = useUnmountedSignal();

   const getMap = useCallback(() => {
      if (!mapRef.current) {
         const map = new mapboxgl.Map({
            container: mapContainerRef.current!,
            style: style,
            center: center,
            zoom: zoom,
            maxZoom: 21,
         });

         if (controlPosition) {
            map.addControl(new mapboxgl.NavigationControl({
               showCompass: false
            }), controlPosition);
         }

         map.on("move", () => {
            const mapCenter = map.getCenter();
            unmountedSignal.aborted || setCenter({
               lat: mapCenter.lat,
               lng: mapCenter.lng,
            });
            unmountedSignal.aborted ||setZoom(map.getZoom());
         });

         mapRef.current = map;
      }

      return mapRef.current;
   }, []);

   return {
      getMapbox: getMap,
      mapContainerRef,
      addMarker: (options: CreateMarkerOptions) => {
         return createMarker(options)
            .addTo(getMap());
      }
   }
}

export default useMapbox;